module.exports = "https://trybtryb-legacy.web.app/img/to_bottom.844821de.svg";